import { Link } from "@mui/material";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import React from "react";

export const MWCBBallLink = () => (
  <Link
    target="_blank"
    href="https://am.ticketmaster.com/mountainwest/"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    Account Manager
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Sessions",
    description: "Select your game pack.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Mountain West account using our secure Ticketmaster Account Login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Mountain West <MWCBBallLink /> within
        24 hours of redemption. Reach out to Live Fan Support for any questions
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the MW Conference Championship Flex Program work?",
    description:
      "The MW Conference Championship Flex Program allows fans to select any seats for any championship session. Games can be purchased in 3 or 5 game packs for max savings.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Mountain West{" "}
        <MWCBBallLink />.
      </>
    ),
  },
];

export function TermsAndCondition() {
  return (
    <>
      <>
        By purchasing you agree to receive SMS alerts regarding ticket delivery
        and agree to the{" "}
        <Link
          href={
            "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
          }
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Terms & Conditions
        </Link>{" "}
        and{" "}
        <Link
          href={
            "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
          }
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Privacy Policy
        </Link>
        .
      </>
    </>
  );
}

export const purchaseSeatsLanguages = {
  sectionSelectorDescription: "Show Session with seats in:",
  findGamesTitle: "Featured Sessions",
  allUpcomingEventsTitle: "All Upcoming Sessions",
  purchaseSeatTabTitle: "Choose Sessions",
  noSessionsAvailable: "No sessions available",
  progressBarSuccessText: "You're good to go!",
  bottomBarEventsDescription: "Session",
  progressBarText:
    "Add 3 games and get 15% off or add 5 games and get 20% off your tickets!",
  progressBarGameText: "session",
};
